import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {httpService} from '../../../core/services/http.service';
import {CommunicationsReportFilterRecord} from './communications-report-filter.record';

export class CommunicationsReportDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/communications_report';

    exportReport(filter: CommunicationsReportFilterRecord): Window {
        const url: string =
            httpService.getBaseUrl() +
            this.apiPath +
            '/csv?' +
            Object.keys(filter)
                .map((key) => key + '=' + filter[key])
                .join('&');
        const result: Window = window.open(url, '_blank');
        return result;
    }
}
